import { ComponentType } from 'react'

import { DrugRegistryRoot } from '../routes/DrugRegistry/DrugRegistryRoot'
import { NotFound404Root } from '../routes/NotFound404/NotFound404Root'
import { OptimizationProcessRoot } from '../routes/OptimizationProcess/OptimizationProcessRoot'
import { OptimizationProcessesRoot } from '../routes/OptimizationProcesses/OptimizationProcessesRoot'
import { SettingsRoot } from '../routes/Settings/SettingsRoot'
import { LoginRoot } from '../routes/SignIn/LoginRoot'
import { LoggedInTemplate } from '../templates/LoggedInTemplate'
import { SignInTemplate } from '../templates/SignInTemplate'

export interface Route {
  path: string
  exact: boolean
  isPrivate: boolean
  redirect?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: ComponentType<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  template?: ComponentType<any>
}

export const routes: Route[] = [
  {
    path: '/',
    exact: true,
    isPrivate: true,
    redirect: '/optimization-processes',
  },
  {
    path: '/settings',
    exact: true,
    isPrivate: true,
    component: SettingsRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/sign-in',
    exact: true,
    isPrivate: false,
    component: LoginRoot,
    template: SignInTemplate,
  },
  {
    path: '/optimization-processes',
    exact: true,
    isPrivate: true,
    component: OptimizationProcessesRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/optimization-processes/:optimizationProcessId',
    exact: true,
    isPrivate: true,
    component: OptimizationProcessRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/drug-registry',
    exact: true,
    isPrivate: true,
    component: DrugRegistryRoot,
    template: LoggedInTemplate,
  },
  {
    path: '*',
    exact: false,
    isPrivate: true,
    component: NotFound404Root,
    template: LoggedInTemplate,
  },
]
